import {dataTestId} from '@hconnect/uikit'
import {NumberSelect} from '@hconnect/uikit/src/lib2/components/dateTimeStepper/NumberSelect'
import {Box, InputAdornment, TextField, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

const MIN_TIMEOUT = 1
const MAX_TIMEOUT = 60
const TIMEOUT_STEP = 5

interface OptimizerSettingsTimeoutInputProps {
  errorMessage?: string
  value: number
  setValue: (value: number) => void
}

export const OptimizerSettingsTimeoutInput: React.FC<OptimizerSettingsTimeoutInputProps> = ({
  errorMessage,
  value,
  setValue
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const onMinusButtonClick = () => {
    const newValue = value - TIMEOUT_STEP
    setValue(newValue <= MIN_TIMEOUT ? MIN_TIMEOUT : newValue)
  }

  const onPlusButtonClick = () => {
    const newValue = value + TIMEOUT_STEP
    setValue(newValue >= MAX_TIMEOUT ? MAX_TIMEOUT : newValue)
  }

  const onTimeoutChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (newValue.trim() === '' || !Number.isFinite(Number(newValue))) {
      return
    }
    const timeout = Number(newValue)
    setValue(timeout < MIN_TIMEOUT ? MIN_TIMEOUT : timeout > MAX_TIMEOUT ? MAX_TIMEOUT : timeout)
  }

  return (
    <Box sx={{position: 'relative', display: 'inline-block'}}>
      <NumberSelect
        title={t('optimizer.timeoutAfter')}
        minusButtonProps={{
          onClick: onMinusButtonClick,
          disabled: value <= MIN_TIMEOUT,
          'data-test-id': 'timeout-minus-button'
        }}
        plusButtonProps={{
          onClick: onPlusButtonClick,
          disabled: value >= MAX_TIMEOUT,
          'data-test-id': 'timeout-plus-button'
        }}
        sx={{width: ({spacing}) => spacing(30)}}
      >
        <TextField
          value={`${value}`}
          InputProps={{
            endAdornment: <InputAdornment position="start">{t('common.min')}</InputAdornment>
          }}
          onChange={onTimeoutChange}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '& .MuiInputBase-input': {
              width: ({spacing}) => spacing(3.5),
              padding: 0,
              textAlign: 'center'
            }
          }}
          {...dataTestId('timeout_input')}
        />
      </NumberSelect>
      {errorMessage && (
        <Typography
          position="absolute"
          top="100%"
          left={14}
          textAlign="center"
          variant="caption"
          color="error"
          {...dataTestId('timeout_error_message')}
        >
          {errorMessage}
        </Typography>
      )}
    </Box>
  )
}
